import getCookie from '@/utils/getCookie';
import router from './index';
import store from '@/store';
import {ROUTE_CAFE24_DASHBOARD, ROUTE_CAFE24_INIT} from '@/router/routeNames';
import {CAFE24_COMPLETE_INIT, CAFE24_SET_MALL} from '@/store/modules/cafe24';
import {AUTH_SET_AUTH_TOKEN} from '@/store/modules/auth';

export const checkAuth = (to, from, next) => {
    if (getCookie('signToken')) {
        next();
    } else {
        window.location.replace('https://printingdiy.gallery/');
    }
};

/**
 * 카페24 파트너 인증 확인
 *
 * @param to
 * @param from
 * @param next
 */
export const checkCafe24PartnerAuth = async (to, from, next) => {
    if (!store.state.auth.authToken) {
        router.push({name: ROUTE_CAFE24_INIT, query: to.query});
        return;
    }

    const isAdminOnly = to.meta.isAdmin || to.matched.find(r => r.meta.isAdmin)?.meta.isAdmin || false;
    if (isAdminOnly) {
        // admin 만 접근 가능
        if (!store.state.auth.partner.isAdmin) {
            router.replace({name: ROUTE_CAFE24_DASHBOARD});
            return;
        }
    }

    next();
};

/**
 * cafe24 코드 발급
 *
 * hmac: "1RzG1S0Q7ksjL"
 * lang: "ko_KR"
 * mall_id: ""
 * nation: "KR"
 * shop_no: "1"
 * timestamp: "1592111047"
 * user_id: ""
 * user_name: ""
 * user_type: "P"
 *
 * @param to
 * @param from
 * @param next
 */
export const cafe24Init = async (to) => {
    console.log('### init...');
    const mallId = to.query.mall_id;
    const clientId = process.env.VUE_APP_CAFE24_CLIENT_ID;
    const redirectUrl = encodeURIComponent(`${window.location.origin}/cafe24`);
    const scope = 'mall.read_product,mall.write_product,mall.read_category,mall.write_category,mall.read_application,mall.write_application,mall.read_order';

    const token = 'PD' + (new Date()).getTime();
    await store.dispatch(CAFE24_SET_MALL, {
        token,
        mallId,
        shopNo: to.query.shop_no,
        userId: to.query.user_id,
        userName: to.query.user_name,
        userType: to.query.user_type,
    });
    window.location.href = `https://${mallId}.cafe24api.com/api/v2/oauth/authorize?response_type=code&client_id=${clientId}&state=${token}&redirect_uri=${redirectUrl}&scope=${scope}`;
};

/**
 * cafe24 코드 검증
 *
 * @param to
 * @param from
 * @param next
 */
export const checkCafe24Code = async (to, from, next) => {
    if (!store.state.cafe24.isInit) {
        if (to.query.code) {
            const {authToken, partner} = await store.dispatch(CAFE24_COMPLETE_INIT, {
                code: to.query.code,
                token: to.query.state,
            });
            await store.dispatch(AUTH_SET_AUTH_TOKEN, {authToken, partner});
        } else {
            // 재인증 시도
            router.push({name: ROUTE_CAFE24_INIT, query: to.query});
            return;
        }
    }

    next();
};